var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkAddMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09287 0.726562H0.98573C0.754342 0.726563 0.532432 0.818481 0.368816 0.982097C0.2052 1.14571 0.113281 1.36762 0.113281 1.59901V11.196C0.11332 11.2738 0.134191 11.3502 0.17373 11.4173C0.213268 11.4843 0.270033 11.5396 0.338133 11.5773C0.406233 11.615 0.483188 11.6339 0.56101 11.6318C0.638833 11.6298 0.714688 11.6069 0.780705 11.5657L4.0393 9.52903L7.29844 11.5657C7.36445 11.6068 7.44025 11.6295 7.51799 11.6315C7.59573 11.6335 7.67259 11.6146 7.7406 11.5769C7.80862 11.5392 7.86532 11.484 7.90483 11.417C7.94434 11.35 7.96522 11.2737 7.96532 11.196V1.59901C7.96532 1.36762 7.8734 1.14571 7.70979 0.982097C7.54617 0.818481 7.32426 0.726563 7.09287 0.726562ZM7.09287 10.4091L4.26996 8.64513C4.20062 8.6018 4.12051 8.57882 4.03876 8.57882C3.957 8.57882 3.87689 8.6018 3.80756 8.64513L0.98573 10.4091V1.59901H7.09287V10.4091Z",
    fill: "white",
    fillOpacity: 0.56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAddMini);
export default __webpack_public_path__ + "static/media/bookmark-add-mini.2d6dc78559c600f13580241868c33c30.svg";
export { ForwardRef as ReactComponent };